import { AddSummaryModal } from "./AddSummaryModal";

export default AddSummaryModal;
